import { Component, Input, OnInit } from '@angular/core';
import { EnumUsuarioEventoAcesso } from '../../enums/usuario-evento-acesso.enum';
import { IUsuarioEventoAcesso, UsuarioEventoAcessoData } from '../../interfaces/usuario-evento-acesso-data.interface';

/** Componente para exibir o badge do evento de acesso do usuário */
@Component({
  selector: 'sgt-usuario-badge-evento-acesso',
  templateUrl: './badge-evento-acesso.component.html',
})
export class UsuarioBadgeEventoAcessoComponent implements OnInit {
  /** Evento de acesso do usuário */
  @Input() evento: EnumUsuarioEventoAcesso;

  eventoData: IUsuarioEventoAcesso;

  ngOnInit(): void {
    this.eventoData = UsuarioEventoAcessoData[this.evento];
  }
}
